import React from 'react';
import {
  CardMedia,
  Card,
  Typography,
  CardTitle,
  CardActions,
  Button,
  CardBody
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CreateAProject } from '@thd-olt-component-react/project-forms';
import ProjectsHeader from '../ProjectsHeader';
import { nullStatePropTypes } from './nullStatePropTypes';
import fallbackViewTexts from '../../constants/fallbackViewTexts';
import {
  handleProjectCreationFromNullState,
  triggerProjectsInteractionAnalytics,
} from '../../utils/helpers';

const DesktopNullView = ({
  cardTitle,
  bodyText,
  imageAlt,
  imageUrl,
  buttonText,
  learnMoreText,
  componentId
}) => {

  return (
    <Card
      data-component="Projects"
      data-testid="projects-null-container"
      className="sui-h-full"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-h-full',
          'sui-p-4',
          'sui-w-full'
        )
      }}
    >
      <div className="sui-flex sui-gap-4 sui-h-full">
        <div
          className={classNames(
            'sui-flex',
            'sui-flex-col',
            'sui-gap-4',
            'sui-h-full',
            'sui-min-w-64',
            'sui-w-full'
          )}
        >
          <div className="sui-mb-4">
            <ProjectsHeader
              hideActions
              componentId={componentId}
            />
          </div>
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={cardTitle}
          />

          <CardBody>
            <div className="sui-pr-10">
              <Typography>{bodyText}</Typography>
            </div>
          </CardBody>

          <CardActions className="sui-flex sui-flex-row sui-gap-4">
            <div className="sui-w-full @xl:sui-w-auto">
              <Button
                fullWidth
                variant="secondary"
                href={fallbackViewTexts.learnMoreLink}
                onClick={() => triggerProjectsInteractionAnalytics({
                  action: 'button-click',
                  id: componentId,
                  component: 'learn more',
                })}
              >{learnMoreText}
              </Button>
            </div>

            <div className="sui-w-full @xl:sui-w-auto">
              <QueryProvider cacheKey="desktop-null-view-create-project">
                <CreateAProject
                  // eslint-disable-next-line max-len
                  onCreate={(newProject) => handleProjectCreationFromNullState({ newProject, hasProjects: false, componentId })}
                  CustomCreateProjectActionElement={({ onClick }) => {
                    const handleBeforeCreateClick = (eve) => {
                      triggerProjectsInteractionAnalytics({
                        action: 'button-click',
                        id: componentId,
                        component: 'create new',
                      });

                      onClick(eve);
                    };

                    return (
                      <Button
                        variant="primary"
                        fullWidth
                        onClick={handleBeforeCreateClick}
                        data-component-id={componentId}
                        aria-label="Create New"
                      >
                        {buttonText}
                      </Button>
                    );
                  }}
                />
              </QueryProvider>
            </div>
          </CardActions>
        </div>
        <div className="sui-w-full">
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={classNames(
              'sui-w-full',
              'sui-h-full',
              'sui-transform',
              'sui-object-cover',
              'sui-object-center'
            )}
          />
        </div>
      </div>
    </Card>

  );
};

DesktopNullView.propTypes = nullStatePropTypes;
DesktopNullView.defaultProps = {
  cardTitle: '',
  bodyText: '',
  imageAlt: '',
  imageUrl: '',
};
export default DesktopNullView;
